module.exports = __webpack_public_path__ + "img/1.f8a3df37.webp";